import React from "react";
import { useSelector } from "react-redux";
import Classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import Register from "./Register";
import OTP from "../../assets/components/Otpcontainer";
import CheckUserExitsts from "./CheckUserExitst";

const Login = () => {
  const { showRegister } = useSelector(({ user }) => user);
  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className={Classes.contentContainer}>
          {!showRegister ? <CheckUserExitsts /> : <Register />}
        </div>
      </div>
      <OTP />
    </AnimatedPageContainer>
  );
};

export default Login;
